export const getValue = (data, onlyLeaf, mergeValue, multiple, config) => {
    let result;
    if (multiple) {
        result = data || [];
        if (onlyLeaf) {
            result = result.filter(item => !item.children);
        }
        if (mergeValue) {
            result = result.filter(item => !(data || []).find(item2 => item2.id === item.parentId));
        }
        return result.map(item => item[config.value]);
    }
    result = data || {};
    return result[config.value] || '';
};

export const getItems = (data, onlyLeaf, mergeValue, multiple) => {
    let result;
    if (multiple) {
        result = (data || []).filter(item => !item.beUndefined);
        if (onlyLeaf) {
            result = result.filter(item => !item.children);
        }
        if (mergeValue) {
            result = result.filter(item => !data.find(item2 => item2.id === item.parentId));
        }
    } else {
        result = data;
    }
    return result;
};

export const findNodeInTree = (val, data, key) => {

    let result;
    for (let i = 0; i < data.length; i++) {
        if (data[i][key] === val) {
            result = data[i];
        } else if (data[i].children) {
            result = findNodeInTree(val, data[i].children, key);
        }
        if (result) {
            break;
        }
    }
    return result;
};
